<h2 class="card-title text-left">{{name}}</h2>

<div class="row">
	<div class="col-12">
		<ng-content></ng-content>
	</div>
</div>
